<template>
  <transition :name="transitionName">
    <router-view class="child-view"></router-view>
  </transition>
</template>
<script>
import updateUpdate from '@/utils/wxConfig'
export default {
        name: 'app',
        data () {
            return {
                transitionName: 'slide-left'
            }
        },
        //监听路由的路径，可以通过不同的路径去选择不同的切换效果
        watch: {
            '$route' (to, from) {
                if(to.path == '/'){
                    this.transitionName = 'slide-right';
                }else{
                    this.transitionName = 'slide-left';
                }
            }
        },
        mounted(){
                updateUpdate();

            // setTimeout(()=>{
        //    },1000)
        },
    }
</script>




// WEBPACK FOOTER //
// src/App.vue